import Phaser from 'phaser';
import { GAME_CONFIG } from './game/config/game.config';

// Initialize the game
new Phaser.Game(GAME_CONFIG);
